export default {
      id: "watch-usage",
      viewBox: "0 0 25 32",
      url: __webpack_public_path__ + "icons/mvm-icons.svg#watch",
      toString: function () {
        return this.url;
      }
    }